import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

function PageHelmet({ title, description }) {
  const metaData = [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
  ];

  return (
    <Helmet meta={metaData} defaultTitle={title}>
      <title>{title}</title>
    </Helmet>
  );
}

PageHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default React.memo(PageHelmet);
